import React from 'react';
import FormPage from '../shared/FormPage';
import useCreateCompanyStore from '../../stores/createCompanyStore';
import { PRIMARY_GOAL_LABELS } from './StartingModulesPage';

const CompanyCreatedPage = ({
  onBackToLogin,
}) => {
  const { formData } = useCreateCompanyStore();
  const startingWith = PRIMARY_GOAL_LABELS[formData.primaryGoal];

  const handleGoToLogin = () => {
    if (onBackToLogin) {
      onBackToLogin();
    }
  };

  return (
    <FormPage
      title="Your company is ready 🎉"
      subtitle="One last step: create your password from the email we just sent"
      inputType="none"
      showNext={false}
      showPrevious={false}
    >
      <div className="space-y-6">
        {/* Success Icon */}
        <div className="flex justify-center">
          <div className="w-16 h-16 bg-gradient-to-br from-green-500 to-green-700 rounded-full flex items-center justify-center shadow-lg">
            <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
        </div>

        <div className="rounded-2xl border border-violet-100 bg-violet-50 p-5 text-center">
          <p className="text-xs font-semibold uppercase tracking-wide text-violet-700">
            Setup email sent to
          </p>
          <p className="mt-2 break-words text-base font-semibold text-violet-900">
            {formData.email || 'your email address'}
          </p>
          <p className="mt-3 text-sm leading-relaxed text-violet-800">
            Open that email and select the secure setup link. You’ll create your
            password, be signed in automatically, and continue in Rightwork.
          </p>
        </div>

        <div className="rounded-2xl border border-gray-100 bg-gray-50/70 p-5">
          <h3 className="font-semibold text-gray-900">What happens next</h3>
          <div className="mt-4 space-y-4">
            <div className="flex items-start gap-3">
              <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-green-100 text-green-700">
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">Company created</p>
                <p className="mt-0.5 text-sm text-gray-600">{startingWith
                    ? `Your account starts with ${startingWith}. You can change this anytime.`
                    : 'Your recommended starting setup is already in place.'}</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-violet-700 text-white">
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8m-16 9h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">Check your email</p>
                <p className="mt-0.5 text-sm text-gray-600">The setup link is the secure way into your new account.</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-full bg-gray-200 text-gray-600">
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">Create your password and enter Rightwork</p>
                <p className="mt-0.5 text-sm text-gray-600">The email link signs you in automatically when you finish.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center">
          <p className="text-sm text-gray-500">
            Don’t see it? Check your spam or promotions folder. It may take a minute to arrive.
          </p>
          <button
            onClick={handleGoToLogin}
            className="mt-4 text-sm font-medium text-violet-700 transition-colors hover:text-violet-900"
          >
            Already finished setup? Return to sign in
          </button>
        </div>
      </div>
    </FormPage>
  );
};

export default CompanyCreatedPage;
